import BaseDialog from "@/components/BaseDialog";
// 添加文件白名单
export function addFileWhiteDialog({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('./addFileWhiteDialog.vue'),
    options: {
      width: '600px',
      title: '添加文件',
      closeOnPressEscape:false,
      closeOnClickModal:false,
    },
    props,
    cbs
  })
}
export function addFileSeparateQueueeDialog({ props, cbs }) {
    return new BaseDialog({
      component: ()=>import('./addFileSeparateQueueeDialog.vue'),
      options: {
        width: '600px',
        title: '添加文件',
        closeOnPressEscape:false,
        closeOnClickModal:false,
      },
      props,
      cbs
    })
  }
